<template>
  <div id="loginScreen">
    <div id="loginNav">
      <div id="loginBox">
        <h1 style="margin-top: 0">Google Authentication</h1>

        <p>
          This app will help you authenticate with Google Drive to give Moonarch
          access to the files of your choosing.
        </p>

        <button id="signin">
          <span class="gIcon">
            <!-- Google Logo -->
            <svg height="24" viewBox="0 0 24 24" width="24">
              <!-- SVG Paths -->
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
              <path d="M1 1h22v22H1z" fill="none" />
            </svg>
          </span>
          <span style="width: 290px; text-align: center"
            >Sign In with Google</span
          >
        </button>

        <button id="pick" style="display: none">
          <span class="gIcon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              width="25"
              height="25"
            >
              <path
                fill="#43a047"
                d="M37,45H11c-1.657,0-3-1.343-3-3V6c0-1.657,1.343-3,3-3h19l10,10v29C40,43.657,38.657,45,37,45z"
              />
              <path fill="#c8e6c9" d="M40 13L30 13 30 3z" />
              <path fill="#2e7d32" d="M30 13L40 23 40 13z" />
              <path
                fill="#e8f5e9"
                d="M31,23H17h-2v2v2v2v2v2v2v2h18v-2v-2v-2v-2v-2v-2v-2H31z M17,25h4v2h-4V25z M17,29h4v2h-4V29z M17,33h4v2h-4V33z M31,35h-8v-2h8V35z M31,31h-8v-2h8V31z M31,27h-8v-2h8V27z"
              />
            </svg>
          </span>
          <span style="width: 270px; text-align: center"
            >Select Google Sheets</span
          >
        </button>
        <div id="sel" style="margin-top: 20px; display: none">
          <p>Thank you, Moonarch now has access to:</p>
          <div id="selected-folder"><span id="name"></span><br /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { supabase } from "../../../main";
import axios from "axios";
// import { onMounted } from 'vue';

/* global google gapi */
export default {
  name: "GoogleDriveAuth",
  data() {
    return {
      CLIENT_ID:
        "69951526839-4ka4mupun9f2lk1p3fusmdar83kmghgs.apps.googleusercontent.com",
      SCOPES: "https://www.googleapis.com/auth/drive",
      API_KEY: "AIzaSyAIiO9BCJV_CBYtyjawkrPUWQEVvef5YmY",
      accessToken: "",
      authTokens: null,
      codeClient: null,
    };
  },
  methods: {
    loadGoogleApis() {
      return new Promise((resolve) => {
        let scriptsLoaded = 0;

        function checkIfDone() {
          scriptsLoaded++;
          if (scriptsLoaded === 2) resolve();
        }

        if (!document.getElementById("gapi-script")) {
          const gapiScript = document.createElement("script");
          gapiScript.src = "https://apis.google.com/js/api.js";
          gapiScript.id = "gapi-script";
          gapiScript.onload = checkIfDone;
          document.head.appendChild(gapiScript);
        } else {
          checkIfDone();
        }

        if (!document.getElementById("google-client")) {
          const gisScript = document.createElement("script");
          gisScript.src = "https://accounts.google.com/gsi/client";
          gisScript.id = "google-client";
          gisScript.onload = checkIfDone;
          document.head.appendChild(gisScript);
        } else {
          checkIfDone();
        }
      });
    },
    async initGis() {
      this.codeClient = google.accounts.oauth2.initCodeClient({
        client_id: this.CLIENT_ID,
        scope: this.SCOPES,
        access_type: "offline",
        prompt: "consent",
        ux_mode: "popup",
        callback: this.handleCodeExchange,
      });

      const signinButton = document.getElementById("signin");
      if (signinButton) {
        signinButton.onclick = () => this.codeClient.requestCode();
      }
    },
    async handleCodeExchange({ code }) {
      try {
        // const {
        //   data: { user },
        // } = await supabase.auth.getUser();

        const res = await axios.post(
          "https://moonarchio--moonarch-automations-api-functions.modal.run/google-oauth-exchange",
          JSON.stringify({
            code,
          }),
          {
            headers: { "Content-Type": "application/json" },
            mode: "cors",
            transformRequest: [(data) => data], // prevent axios from re-serializing
          }
        );

        this.authTokens = res.data.auth_tokens;
        this.accessToken = res.data.access_token;
        document.getElementById("signin").style.display = "none";
        const pickButton = document.getElementById("pick");
        if (pickButton) {
          pickButton.style.display = "flex";
          pickButton.onclick = this.handlePicker;
        }
      } catch (err) {
        console.error("OAuth exchange failed:", err);
        alert("OAuth exchange failed");
      }
    },
    initGapi() {
      gapi.load("client:picker");
    },
    handlePicker() {
      const picker = new google.picker.PickerBuilder()
        .addView(
          new google.picker.DocsView()
            .setIncludeFolders(true)
            .setSelectFolderEnabled(true)
            .setMimeTypes("application/vnd.google-apps.spreadsheet")
        )
        .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setOAuthToken(this.accessToken)
        .setDeveloperKey(this.API_KEY)
        .setOrigin(window.location.origin)
        .setCallback(this.handleFilePicked)
        .build();

      picker.setVisible(true);
    },
    async handleFilePicked(data) {
      if (data.action === google.picker.Action.PICKED) {
        const { docs } = data;
        const nameContainer = document.getElementById("name");
        const selBox = document.getElementById("sel");

        nameContainer.innerHTML = ""; // Clear existing entries

        const {
          data: { user },
        } = await supabase.auth.getUser();

        for (const f of docs) {
          // Append file name
          const p = document.createElement("p");
          p.textContent = f.name;
          nameContainer.appendChild(p);

          // Store each file individually
          await axios.post(
            "https://moonarchio--moonarch-automations-api-functions.modal.run/store-google-tokens",
            JSON.stringify({
              folder_id: f.id,
              folder_name: f.name,
              auth_tokens: this.authTokens,
              user_id: user.id,
            }),
            {
              headers: { "Content-Type": "application/json" },
              mode: "cors",
              transformRequest: [(data) => data],
            }
          );
        }

        selBox.style.display = "block";
      }
    },
  },
  mounted() {
    this.loadGoogleApis().then(() => {
      this.initGis();
      this.initGapi();
    });
  },
};
</script>

<style scoped>
#loginScreen {
  /* height: calc(100vh - 50px); */
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f4ff;
  flex-direction: column;
  position: absolute;
  z-index: 1;
}
#loginNav {
  top: 0;
  left: 0;
  right: 0;
  bottom: 200px;
  padding: 20px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
#loginBox {
  border: thin #0000002e solid;
  box-shadow: 0 0px 8px 0 #0000001d;
  background: #fefefe;
  border-radius: 15px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* height: 260px; */
  height: fit-content;
  width: 350px;
  padding: 30px;
  /* align-items: center; */
  /* justify-content: space-between; */
}
.google-drive-container {
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

button {
  /* margin: 0px 5px; */
  background: #731cff;
  border: thin #b78aff solid;
  box-shadow: 0 0 0 1px #731cff;
  cursor: pointer !important;
  padding: 0px 20px 0 4px;
  border-radius: 7px;
  font-family: sans-serif;
  font-size: 16px;
  color: white;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 40px;
  margin-top: 20px;
}
button:hover {
  background: #9f63ff;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

#selected-folder {
  margin-top: 20px;
  padding: 10px;
  background-color: #f1f1f1;
  border-radius: 4px;
}

.credential-section {
  margin-top: 30px;
  border-top: 1px solid #ccc;
  padding-top: 20px;
}

textarea {
  width: 100%;
  box-sizing: border-box;
  font-family: monospace;
}
.gIcon {
  height: 30px;
  width: 30px;
  /* margin-right: 20px; */
  border-radius: 5px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
